import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { getExpertDetailById } from "../api/_request";
import { useNavigate } from 'react-router-dom';

const ExpertCard = ({ item }) => {
  const [expertData, setExpertData] = useState();
  const [isActive, setIsActive] = useState();
  const expertId = item?._id;
  const navigate = useNavigate();
  // console.log("itemitem", item)

  let body = {
    Country: "India",
    q: null,
    Profession: "",
    Experience: null,
    MinPrice: 0,
    MaxPrice: 20000,
    PageNumber: 0,
    RowsOfPage: 3,
    Category: null,
    ExpertId: expertId,
  };
  useEffect(() => {
    getExpertDetailById(body).then((resp) => {
      if (resp?.ResponseCode === 200) {
        setExpertData(resp?.data[0]);
      } else {
        console.log(resp.ResponseMessage);
      }
    });
  }, [item?._id]);

  return (
    <div className="Search--expertCard">
      <div className="d-flex gap-3">
        <div>
          <img src={item?.ProfileImage} alt="" className="expert-img" />
        </div>
        <div className="expertDetail my-auto d-flex flex-column gap-2">
          <h5>{item?.Name}</h5>
          <p>{item?.RegisterYourselfAs}</p>
          <p>{item?.Experience}+ Years of Experience</p>
          {/* <div className="d-flex align-items-center gap-2">
            <p>{expertData?.ReviewsCount} Reviews</p>
          </div> */}
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-center mt-3 nextAvailability ">
        {/* <div className="d-flex gap-2 mt-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
          >
            <path
              d="M21.875 4H21V3.125C21 2.64178 20.6082 2.25 20.125 2.25C19.6418 2.25 19.25 2.64178 19.25 3.125V4H8.75V3.125C8.75 2.64178 8.35822 2.25 7.875 2.25C7.39178 2.25 7 2.64178 7 3.125V4H6.125C3.71277 4 1.75 5.96277 1.75 8.375V22.375C1.75 24.7872 3.71277 26.75 6.125 26.75H21.875C24.2872 26.75 26.25 24.7872 26.25 22.375V8.375C26.25 5.96277 24.2872 4 21.875 4ZM6.125 5.75H7V6.625C7 7.10822 7.39178 7.5 7.875 7.5C8.35822 7.5 8.75 7.10822 8.75 6.625V5.75H19.25V6.625C19.25 7.10822 19.6418 7.5 20.125 7.5C20.6082 7.5 21 7.10822 21 6.625V5.75H21.875C23.3225 5.75 24.5 6.92749 24.5 8.375V11H3.5V8.375C3.5 6.92749 4.67749 5.75 6.125 5.75ZM21.875 25H6.125C4.67749 25 3.5 23.8225 3.5 22.375V12.75H24.5V22.375C24.5 23.8225 23.3225 25 21.875 25ZM8.75 22.375C8.75 22.8582 8.35822 23.25 7.875 23.25H7C6.51678 23.25 6.125 22.8582 6.125 22.375C6.125 21.8918 6.51678 21.5 7 21.5H7.875C8.35822 21.5 8.75 21.8918 8.75 22.375ZM13.125 22.375C13.125 22.8582 12.7332 23.25 12.25 23.25H11.375C10.8918 23.25 10.5 22.8582 10.5 22.375C10.5 21.8918 10.8918 21.5 11.375 21.5H12.25C12.7332 21.5 13.125 21.8918 13.125 22.375ZM17.5 22.375C17.5 22.8582 17.1082 23.25 16.625 23.25H15.75C15.2668 23.25 14.875 22.8582 14.875 22.375C14.875 21.8918 15.2668 21.5 15.75 21.5H16.625C17.1082 21.5 17.5 21.8918 17.5 22.375ZM21.875 22.375C21.875 22.8582 21.4832 23.25 21 23.25H20.125C19.6418 23.25 19.25 22.8582 19.25 22.375C19.25 21.8918 19.6418 21.5 20.125 21.5H21C21.4832 21.5 21.875 21.8918 21.875 22.375ZM8.75 18.875C8.75 19.3582 8.35822 19.75 7.875 19.75H7C6.51678 19.75 6.125 19.3582 6.125 18.875C6.125 18.3918 6.51678 18 7 18H7.875C8.35822 18 8.75 18.3918 8.75 18.875ZM13.125 18.875C13.125 19.3582 12.7332 19.75 12.25 19.75H11.375C10.8918 19.75 10.5 19.3582 10.5 18.875C10.5 18.3918 10.8918 18 11.375 18H12.25C12.7332 18 13.125 18.3918 13.125 18.875ZM17.5 18.875C17.5 19.3582 17.1082 19.75 16.625 19.75H15.75C15.2668 19.75 14.875 19.3582 14.875 18.875C14.875 18.3918 15.2668 18 15.75 18H16.625C17.1082 18 17.5 18.3918 17.5 18.875ZM21.875 18.875C21.875 19.3582 21.4832 19.75 21 19.75H20.125C19.6418 19.75 19.25 19.3582 19.25 18.875C19.25 18.3918 19.6418 18 20.125 18H21C21.4832 18 21.875 18.3918 21.875 18.875ZM17.5 15.375C17.5 15.8582 17.1082 16.25 16.625 16.25H15.75C15.2668 16.25 14.875 15.8582 14.875 15.375C14.875 14.8918 15.2668 14.5 15.75 14.5H16.625C17.1082 14.5 17.5 14.8918 17.5 15.375ZM21.875 15.375C21.875 15.8582 21.4832 16.25 21 16.25H20.125C19.6418 16.25 19.25 15.8582 19.25 15.375C19.25 14.8918 19.6418 14.5 20.125 14.5H21C21.4832 14.5 21.875 14.8918 21.875 15.375Z"
              fill="#73589B"
            />
          </svg>
          <div style={{ color: "#73589B" }} >
            <p>Next Availability</p>
            <p style={{ color: "#73589B", fontSize: "16px" }} className="fw-semibold">{expertData?.NextAvailability}</p>
          </div>
        </div> */}
        <button variant="contained" className="px-4 py-3" onClick={() => navigate(`/profession/${item?.RegisterYourselfAs}/${item?.Name}/${item?._id}`)}>
          Book Session
        </button>
      </div>
    </div>
  );
};

export default ExpertCard;